import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";
export const fetchAssets = createAsyncThunk("giftCountryManagement/fetchAssets",
	async () => {
		const response = await apiConfig.get("country-management/list");
		return response.data;
	}
);
export const toggelDeleteGiftCountry = createAsyncThunk("giftCountryManagement/toggelDelete", async (wrapperId) => {
	const response = await apiConfig.delete(`country-management/delete/${wrapperId}`);
	const data = await response.data;
	return data;
});

export const updateAsset = createAsyncThunk("giftCountryManagement/updateAsset", async ({ assetId, selectedFile, headers }) => {
	const formData = new FormData();
	try {
		formData.append("file", selectedFile, selectedFile.name);
	} catch (error) {
		console.log(error);
	}
	const response = await apiConfig.post(`country-management/update/${assetId}`, formData, {
		headers,
	});
	const data = await response.data;
	return data;
});
export const addNewCountry = createAsyncThunk("giftCountryManagement/addNewCountry", async (rec_data, { rejectWithValue }) => {
	try {
		const formData = new FormData();
		if (rec_data.image != null) {
			formData.append("file", rec_data.image, rec_data.image.name);
		}
		if (rec_data.imageFlag != null) {
			formData.append("fileFlag", rec_data.imageFlag, rec_data.imageFlag.name);
		}
		const response = await apiConfig.post(`country-management/upload`, formData);
		const data = await response.data.data;
		try {
			if (data.banner != null) {
				let myarray = [];
				const banner = { imageUrl: data.banner.csImageUlr, imageGcpUrl: data.banner.gcpImageUrl };
				myarray = [...myarray, banner];
				rec_data.countryBannerList = myarray;
			}
			if (data.flag != null) {
				console.log(data.flag)
				rec_data.flagUrl = data.flag.csImageUlr;
				rec_data.flagGcpUrl = data.flag.gcpImageUrl;
			}
		} catch (err) {
			console.log(err)
		}
		if (!rec_data.isUpdate) {
			const responseWrapper = await apiConfig.post(`country-management/add`, rec_data);
			return responseWrapper.data;
		} else {
			// update action
			console.log("Update Country Info")
			const responseWrapper = await apiConfig.put(`country-management/update/${rec_data.id}`, rec_data);
			return responseWrapper.data;
		}
	}
	catch (err) {
		console.log("http error:", err)
		const customError = {
			name: "Custom axios error",
			message: err.message,
			status: "Failed",
		};
		return rejectWithValue(customError);
	}
});
const giftCountryManagementSlice = createSlice({
	name: "giftCountryManagement",
	initialState: {
		assets: [],
		countries: [],
		status: null,
		error: null,
		message: null,
		timestamp: null,
		statusNewItem: null,
		addnewitemResponse: null,
	},
	reducers: {},
	extraReducers: {
		[fetchAssets.pending]: (state) => {
			console.log("Pending")
			state.status = "loading";
		},
		[fetchAssets.fulfilled]: (state, action) => {
			const response = action.payload;

			if (response.status === "OK") {
				state.status = "OK";
				state.assets = action.payload.data;
				state.countries = action.payload.data.sections.countries
			} else {
				state.status = "failed";
				state.error = action.message;
			}
		},
		[fetchAssets.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.message;
		},
		[toggelDeleteGiftCountry.fulfilled]: (state, action) => {
			const response = action.payload;

			if (response.status === "OK") {
				const itemIndex = state.assets.findIndex((item) => item.id === action.payload.data.id);
				state.assets[itemIndex] = action.payload.data;
			}
			else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
		[addNewCountry.fulfilled]: (state, action) => {
			const response = action.payload;
			if (response.status === "OK") {
				state.statusNewItem = "OK"; state.status = "OK";
				const itemIndex = state.countries.findIndex((item) => item.id === action.payload.data.id);
				if (itemIndex === -1) {
					state.countries = [...state.countries, action.payload.data];
				} else {

					state.countries[itemIndex] = action.payload.data;
				}
			}
		},
		[addNewCountry.rejected]: (state, action) => {
			console.log("response of adding country is failed:", action)
			state.statusNewItem = "failed"
			state.addnewitemResponse = action.payload.message;


		},
		[updateAsset.fulfilled]: (state, action) => {
			const response = action.payload;
			if (response.status === "OK") {
				const itemIndex = state.countries.findIndex((item) => item.id === action.payload.data.id);
				state.countries[itemIndex] = action.payload.data;
			}
			else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
	},
});
export const assetManagementActions = giftCountryManagementSlice.actions;
export default giftCountryManagementSlice.reducer;
